// extracted by mini-css-extract-plugin
export default {"ChartBox":"PieChartBox_ChartBox__fxkXS","statisticBox":"PieChartBox_statisticBox__MnuWT"};